import * as Yup from "yup";
import moment from "moment";
import { FORMAT } from "utils/dateOfBirthValidation";

export function getPostInitialValues(orderDetails) {
  let equipment0 = false;
  let equipment1 = false;
  let equipment2 = false;
  if (orderDetails?.equipmentRequirements) {
    for (let j = 0; j < orderDetails.equipmentRequirements.length; j++) {
      if (orderDetails.equipmentRequirements[j] === "FLAT_BED") {
        equipment0 = true;
      }
      if (orderDetails.equipmentRequirements[j] === "ENCLOSED_TRAILER") {
        equipment1 = true;
      }
      if (orderDetails.equipmentRequirements[j] === "STRAIGHT_TRUCK") {
        equipment2 = true;
      }
    }
  }

  let condition = "";
  if (orderDetails?.palletDetails?.condition && orderDetails.palletDetails.condition.length > 0) {
    condition = orderDetails.palletDetails.condition[0];
  }

  let palletType = orderDetails?.palletDetails?.palletType?.toLowerCase();
  if (palletType === "euro" || orderDetails?.palletDetails?.palletType === "EUROPALLET") {
    palletType = "euroPallet";
  }

  let requestDeliveryDate = moment(new Date().setDate(new Date().getDate() + 4)).format(FORMAT);
  let loadDetailsRequestDeliveryDate;
  if (orderDetails?.loadDetails?.requestDeliveryDate) {
    loadDetailsRequestDeliveryDate = moment(orderDetails.loadDetails.requestDeliveryDate).format(FORMAT);
  }

  let beginCurrentTime = '00:00';
  if (orderDetails?.loadDetails?.deliveryFromtime) {
    beginCurrentTime = orderDetails.loadDetails.deliveryFromtime;
  }

  let endCurrentTime = "23:00";
  if (orderDetails?.loadDetails?.deliveryTotime) {
    endCurrentTime = orderDetails.loadDetails.deliveryTotime;
  }

  return {
    useMixLoad: false,
    material: orderDetails?.palletDetails?.material || "WOOD",
    condition: condition || "",
    hardOrSoftWood: orderDetails?.palletDetails?.newConditionType === 'SOFTWOOD' ? 'New - Softwood' :
      orderDetails?.palletDetails?.newConditionType === 'HARDWOOD' ? 'New - Hardwood' : '',
    palletType: palletType || "BLOCK",
    moisture: orderDetails?.palletDetails?.moisture || "",
    size: orderDetails?.palletDetails?.size || "",
    grade: orderDetails?.palletDetails?.grade || "",
    isHeatTreared: orderDetails?.palletDetails?.heatTreared || false,
    poNumber: orderDetails?.loadDetails?.poNumber || "",
    lotsOption: orderDetails?.loadDetails?.lotType || "MULTIPLE",

    businessName: orderDetails?.location?.locationId || "",
    requestDeliveryDate: requestDeliveryDate,
    appointment: orderDetails?.loadDetails?.appointment || "DELIVERY_WINDOW",
    appt: beginCurrentTime,
    apptTo: endCurrentTime,
    equipment0: equipment0,
    equipment1: equipment1,
    equipment2: equipment2,
    apptEdit: orderDetails?.loadDetails?.deliveryFromtime || '00:00',
    apptToEdit: orderDetails?.loadDetails?.deliveryTotime || '23:00',
    lots: orderDetails?.loadDetails?.quantityDetails?.lots || "",
    QuantityLot: orderDetails?.loadDetails?.quantityDetails?.quantity || 540,
    originalQuantity: orderDetails?.loadDetails?.quantityDetails?.originalQuantity || 540,
    length: orderDetails?.palletDetails?.length || '',
    width: orderDetails?.palletDetails?.width || '',
    height: orderDetails?.palletDetails?.height || '',
    quantityMaxValue: orderDetails?.loadDetails?.quantityDetails?.originalQuantity || 540,

    addMoreArrList: [{
      lots: orderDetails?.loadDetails?.quantityDetails?.lots || "",
      QuantityLot: orderDetails?.loadDetails?.quantityDetails?.quantity || 540,
      quantityMaxValue: orderDetails?.loadDetails?.quantityDetails?.quantityMaxValue || 540,
      requestDeliveryDate: loadDetailsRequestDeliveryDate ? loadDetailsRequestDeliveryDate : requestDeliveryDate,
      appt: beginCurrentTime,
      apptTo: endCurrentTime,
      poNumber: orderDetails?.loadDetails?.poNumber || ""
    }],
    remark: orderDetails?.remark || "",
    cloneOrder: Boolean(orderDetails?.orderRefNumber || orderDetails?.data?.orderRefNumber),
    orderId: orderDetails?.orderRefNumber || orderDetails?.data?.orderRefNumber || "",
  };
}

export const VALIDATION_SCHEMA = () => {
  return Yup.object().shape({});
};

export const getActiveConditions = (values) => {
  const conds = [];
  if (values.condition === "RECYCLED") conds.push('recycled');
  if (values.condition === "NEW") conds.push('newCondition');
  if (values.condition === "COMBO") conds.push('combo');
  return conds;
};

export const getConditionsFromApi = (apiConditions) => {
  if (!apiConditions) return [];
  return apiConditions.map(c => {
    if (c === "RECYCLED") return "recycled";
    if (c === "NEW") return "newCondition";
    if (c === "COMBO") return "combo";
    return c.toLowerCase();
  });
};

export const getPalletSpecificDetails = (palletDetailResponse, material, activeConditions, palletType) => {
  if (!palletDetailResponse || !material || !palletType) return [];
  const selectedMaterial = material.toLowerCase();
  const selectedPalletType = palletType === "europallet" ? "euroPallet" : palletType;

  let details = [];
  activeConditions.forEach(condKey => {
    const section = palletDetailResponse[selectedMaterial]?.condition?.[condKey]?.[selectedPalletType];
    if (section?.palletSpecificDetails) {
      details = details.concat(section.palletSpecificDetails);
    }
  });
  return details;
};
